import {getWebDomain} from './common'
let domain = getWebDomain();
let htmlprotocol = window.location.protocol;
let loginCookieName = 'lechuncccookieonline';
let analysisLink = 'http://101.201.53.117';


/**
 * global变量(分平台)
 * **/
function getGlobalConstant(){
    let globalCon = {};
    switch (domain){
        case 'lechun.cc':
            globalCon.globalKey = '489430kjrewori430i0if93i943ewoi439';
            globalCon.globalApiUrl = htmlprotocol+"//mallapi."+domain;
            globalCon.globalApiUrlOld = htmlprotocol+"//api."+domain;
            globalCon.globalApiUrlUser = htmlprotocol+"//user."+domain;
            globalCon.globalWebLink = htmlprotocol+"//wx."+domain;
            globalCon.globalWebLinkOld = htmlprotocol+"//wechat."+domain;
            globalCon.sensors_web_url = analysisLink+":8007/?project=default";
            globalCon.sensors_server_url = analysisLink+':8106/sa?project=default';
            break;
        case 'meiriyuanqi.com':
			globalCon.globalKey = '489430kjrewori430i0if93i943ewoi439';
            globalCon.globalApiUrl = htmlprotocol+"//mallapi."+domain;
            globalCon.globalApiUrlOld = htmlprotocol+"//api."+domain;
            globalCon.globalApiUrlUser = htmlprotocol+"//api."+domain;
            globalCon.globalWebLink = htmlprotocol+"//wx."+domain;
            globalCon.globalWebLinkOld = htmlprotocol+"//wx."+domain;
            globalCon.sensors_web_url = analysisLink+":8007/?project=lechun_new";
            globalCon.sensors_server_url = analysisLink+':8106/sa?project=lechun_new';
            break;
        case 'xiaobuji.com':
            globalCon.globalKey = '489430kjrewori430i0if93i943ewoi439';
            globalCon.globalApiUrl = htmlprotocol+"//mallapi."+domain;
            globalCon.globalApiUrlOld = htmlprotocol+"//api."+domain;
            globalCon.globalApiUrlUser = htmlprotocol+"//api."+domain;
            globalCon.globalWebLink = htmlprotocol+"//wx."+domain;
            globalCon.globalWebLinkOld = htmlprotocol+"//wx."+domain;
            globalCon.sensors_web_url = analysisLink+":8007/?project=lechun_new";
            globalCon.sensors_server_url = analysisLink+':8106/sa?project=lechun_new';
            break;
    }
    return globalCon
}
export {loginCookieName,getGlobalConstant}



// WEBPACK FOOTER //
// ./src/resource/js/public_link.js